"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_settings_1 = require("../config/app.settings");
var QUIZ_EVENTS;
(function (QUIZ_EVENTS) {
    QUIZ_EVENTS["QUIZ_PLAYER_MODULE_LOADED"] = "QUIZ_PLAYER_MODULE_LOADED";
    QUIZ_EVENTS["QUIZ_PLAYER_END_QUIZ"] = "QUIZ_PLAYER_END_QUIZ";
    QUIZ_EVENTS["QUIZ_PLAYER_QUESTION_CORRECTION"] = "QUIZ_PLAYER_QUESTION_CORRECTION";
    QUIZ_EVENTS["ON_CLICK_NEXT_QUESTION"] = "ON_CLICK_NEXT_QUESTION";
})(QUIZ_EVENTS = exports.QUIZ_EVENTS || (exports.QUIZ_EVENTS = {}));
/**
 * Quiz service
 */
var QuizService = /** @class */ (function () {
    function QuizService() {
    }
    /**
     * Handle error from api
     * @param error
     */
    QuizService.handleError = function (error) {
        console.log(error);
    };
    QuizService.getQuestionCorrection = function (evt, url, isGeneratedQuiz) { return __awaiter(void 0, void 0, void 0, function () {
        var detail, questionId, userAnswer, callback, realUrl, method, init, requestResponse, questionResponse, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    detail = evt.detail;
                    questionId = detail.questionId, userAnswer = detail.userAnswer, callback = detail.callback;
                    realUrl = url.replace("##questionId##", questionId.toString());
                    method = isGeneratedQuiz ? "PATCH" : "GET";
                    init = isGeneratedQuiz ? { body: JSON.stringify(userAnswer), method: method } : { method: method };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(realUrl, init)];
                case 2:
                    requestResponse = _a.sent();
                    if (!requestResponse.ok) {
                        throw Error("Bad response from server: " + requestResponse.status + " - " + requestResponse.statusText);
                    }
                    return [4 /*yield*/, requestResponse.json()];
                case 3:
                    questionResponse = _a.sent();
                    callback(QuizService.formatQuestionCorrectionResponseForCallback(questionId, questionResponse, userAnswer));
                    return [2 /*return*/, true];
                case 4:
                    e_1 = _a.sent();
                    QuizService.handleError(e_1);
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Get qui data
     * @param id
     */
    QuizService.getQuiz = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var requestResponse, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(app_settings_1.LEARNING_API_ENPOINT + "/quiz/" + id + "?embed=display")];
                case 1:
                    requestResponse = _a.sent();
                    return [4 /*yield*/, requestResponse.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_2 = _a.sent();
                    QuizService.handleError(e_2);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Get quiz correction from api learning and send to quiz player
     * @param evt custom event from quiz player with user answers
     * @param id quiz identifier
     * @param isGeneratedQuiz
     */
    QuizService.getQuizCorrection = function (evt, id, isGeneratedQuiz) { return __awaiter(void 0, void 0, void 0, function () {
        var detail, userAnswers, callback, url, method, init, requestResponse, quizResponse, formattedQuestion, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    detail = evt.detail;
                    userAnswers = detail.userAnswers, callback = detail.callback;
                    url = isGeneratedQuiz ? app_settings_1.LEARNING_API_ENPOINT + "/quiz/" + id + "/validate?strict=true" : app_settings_1.LEARNING_API_ENPOINT + "/quiz/" + id + "/correction?strict=true";
                    method = isGeneratedQuiz ? "PATCH" : "GET";
                    init = isGeneratedQuiz ? { body: JSON.stringify(userAnswers), method: method } : { method: method };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, init)];
                case 2:
                    requestResponse = _a.sent();
                    if (!requestResponse.ok) {
                        throw Error("Bad response from server: " + requestResponse.status + " - " + requestResponse.statusText);
                    }
                    return [4 /*yield*/, requestResponse.json()];
                case 3:
                    quizResponse = _a.sent();
                    formattedQuestion = QuizService.formatQuizCorrectionResponseForCallback(quizResponse, userAnswers);
                    callback(formattedQuestion);
                    return [2 /*return*/, formattedQuestion];
                case 4:
                    e_3 = _a.sent();
                    QuizService.handleError(e_3);
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Format question correction api response for quiz player
     * @param questionId
     * @param questionResponse
     * @param userAnswer
     */
    QuizService.formatQuestionCorrectionResponseForCallback = function (questionId, questionResponse, userAnswer) {
        var _a;
        var subquestionsResponseData = questionResponse.data;
        var subquestionIdList = Object.keys(subquestionsResponseData);
        var successNbr = 0;
        subquestionIdList.forEach(function (subquestionId) {
            delete subquestionsResponseData[subquestionId].success;
            if (Array.isArray(userAnswer[subquestionId])) {
                var numberArray_1 = true;
                userAnswer[subquestionId].forEach(function (value) {
                    if (numberArray_1 && isNaN(value)) {
                        numberArray_1 = false;
                    }
                });
                if (numberArray_1) {
                    userAnswer[subquestionId].sort();
                    subquestionsResponseData[subquestionId].goodAnswer.sort();
                }
                if (userAnswer[subquestionId].toString() === subquestionsResponseData[subquestionId].goodAnswer.toString()) {
                    successNbr++;
                }
            }
            else {
                if (subquestionsResponseData[subquestionId].placeholders) {
                    var indexKeyList = Object.keys(subquestionsResponseData[subquestionId].placeholders);
                    indexKeyList.forEach(function (indexKey) {
                        subquestionsResponseData[subquestionId].placeholders[indexKey].goodAnswers.forEach(function (goodAnswersId) {
                            if (userAnswer[subquestionId] && userAnswer[subquestionId][indexKey] === goodAnswersId) {
                                if (subquestionsResponseData[subquestionId].success !== false) {
                                    subquestionsResponseData[subquestionId].success = true;
                                    successNbr++;
                                }
                            }
                        });
                    });
                }
                else {
                    subquestionsResponseData[subquestionId].goodAnswer.forEach(function (goodAnswersId) {
                        if (userAnswer[subquestionId] === goodAnswersId) {
                            subquestionsResponseData[subquestionId].success = true;
                            successNbr++;
                        }
                    });
                }
            }
            subquestionsResponseData[subquestionId].success = !!subquestionsResponseData[subquestionId].success;
        });
        var question = {
            data: subquestionsResponseData,
            success: successNbr === subquestionIdList.length,
            userScore: successNbr === subquestionIdList.length ? 1 : 0,
        };
        var response = (_a = {}, _a[questionId] = {
            data: question.data,
            explanations: [],
            success: question.success,
            userScore: question.userScore,
        }, _a);
        var subquestions = question.data;
        var subKeys = Object.keys(subquestions);
        var j = 0;
        for (j; j < subKeys.length; j++) {
            if (subquestions[subKeys[j]].explanation) {
                response[questionId].explanations.push(subquestions[subKeys[j]].explanation);
            }
        }
        return response;
    };
    /**
     * Format quiz correction api response for send to quiz player
     * @param quizResponse response from api learning
     * @param userAnswer
     */
    QuizService.formatQuizCorrectionResponseForCallback = function (quizResponse, userAnswer) {
        var questions = quizResponse.data;
        var questionsKeys = Object.keys(questions);
        var formatedQuestions = questionsKeys.reduce(function (previousValue, currentValue) {
            if (!previousValue) {
                return QuizService
                    .formatQuestionCorrectionResponseForCallback(currentValue, questions[currentValue], userAnswer[currentValue]);
            }
            return __assign(__assign({}, previousValue), QuizService.formatQuestionCorrectionResponseForCallback(currentValue, questions[currentValue], userAnswer[currentValue]));
        }, undefined);
        var userScore = Object.keys(formatedQuestions).reduce(function (score, questionId) {
            return score + formatedQuestions[questionId].userScore;
        }, 0);
        return __assign(__assign({}, quizResponse), { data: formatedQuestions, userScore: userScore });
    };
    return QuizService;
}());
exports.default = QuizService;
//# sourceMappingURL=quiz.service.js.map